<template>
  <a-row style="margin-bottom: 12px;">
    <a-col
      :span="12"
      class="admin-console-add-header__title"
      :style="isFocus ? 'font-weight: bold;' : 'font-weight: normal;'"
    >
      {{ title }}
    </a-col>
    <a-col :span="12" style="text-align: right;">
      <a-button class="admin-console-add-header__btn" @click="showAddNewAll">
        <a-icon type="plus" class="admin-console-add-header__btn-icon" />
        Add
      </a-button>
      <a-dropdown v-if="isShowEditBtn">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1"> <a-icon type="edit" />Edit All </a-menu-item>
          <a-menu-item key="2"> <a-icon type="delete" />Delete </a-menu-item>
        </a-menu>
        <a-button class="admin-console-add-header__drop-btn">
          <a-icon type="edit" class="admin-console-add-header__btn-icon" />
          Edit
        </a-button>
      </a-dropdown>
      <!-- <a-button v-else class="admin-console-add-header__btn" @click="saveDelete">
        <a-icon type="save" class="admin-console-add-header__btn-icon" />
        Save
      </a-button> -->
    </a-col>
    <AddNewDialog ref="addNewDialog" @saveNew="addMultiple" />
    <delete-reference-dialog ref="deleteDialog" @doDelete="saveDelete" />
  </a-row>
</template>
<script>
import AddNewDialog from "@/components/admin/AddNewDialog"
import DeleteReferenceDialog from "@/components/admin/DeleteReferenceDialog.vue"
export default {
  components: {
    AddNewDialog,
    DeleteReferenceDialog
  },
  props: {
    title: { type: String, default: "title" },
    items: { type: Array, default: () => [] },
    isFocus: { type: Boolean, default: false },
    isShowEditBtn: { type: Boolean, default: true }
  },
  methods: {
    //all this operation is for all the items
    addMultiple(newValues) {
      this.$emit("addMultiple", newValues)
    },
    handleMenuClick(e) {
      console.log("click", e)
      if (e.key === "1") {
        this.editAll()
      } else {
        this.showDeleteDialog()
      }
    },
    editAll() {
      this.$emit("editAll")
    },
    showAddNewAll() {
      this.$refs["addNewDialog"].openDialog(this.items, this.title)
    },
    showDeleteDialog() {
      this.$refs["deleteDialog"].openDialog(this.items)
    },
    showDeleteIcon() {
      this.$emit("clickDeleteAll")
    },
    saveDelete(data) {
      this.$emit("saveDelete", data)
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-console-add-header {
  &__title {
    font-family: Proxima Nova;
    font-style: normal;
    font-size: 22px;
    line-height: 29px;
    display: flex;
    align-items: center;
    color: #262626;
    text-transform: uppercase;
  }
  &__btn {
    font-family: Proxima Nova;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    background: #4a8a5d;
    color: #fff;
    padding: 0px 8px !important;
    border: 1px solid #4a8a5d !important;
    border-radius: 2px !important;
    margin-right: 12px;
    height: auto !important;
  }
  &__drop-btn {
    font-family: Proxima Nova;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    background: #4a8a5d;
    color: #fff;
    padding: 0px 20px !important;
    border: 1px solid #4a8a5d !important;
    border-radius: 2px !important;
    margin-right: 12px;
    height: auto !important;
  }
  &__btn-icon {
    vertical-align: middle;
    line-height: normal;
    margin-bottom: 4px;
  }
}
.admin-console-add-header__btn:hover,
.admin-console-add-header__btn:focus,
.admin-console-add-header__btn:active,
.admin-console-add-header__btn.active,
.admin-console-add-header__drop-btn:hover,
.admin-console-add-header__drop-btn:focus,
.admin-console-add-header__drop-btn:active,
.admin-console-add-header__drop-btn.active {
  background-color: #e2eeec;
}
.admin-console-add-header__btn:hover,
.admin-console-add-header__btn:focus,
.admin-console-add-header__drop-btn:hover,
.admin-console-add-header__drop-btn:focus {
  color: #4a8a5d;
}
</style>
